module.exports = __webpack_public_path__ + "b3be49533fdb4b90eb62b8499b1f3588.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-night-beach.png
// module id = 1610
// module chunks = 0